
/**
 * 트윗 유형
 */
export type ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType = typeof ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType[keyof typeof ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
